import fetch from '@/utils/fetch'

// 加载常用收货人
export function loadReceiverList () {
  return fetch({
    url: '/comm/shippingAddress/list',
    method: 'post'
  })
}

// 保存常用收货人地址
export function saveReceiverInfo (data) {
  return fetch({
    url: '/comm/shippingAddress/save',
    method: 'post',
    data
  })
}

// 更新常用收货人地址
export function updateReceiverInfo (data) {
  return fetch({
    url: '/comm/shippingAddress/update',
    method: 'post',
    data
  })
}

// 单品下单
export function createOrder (data, from) {
  let url = '/website/retail/order/create'
  if (from === 'cart') {
    url = '/website/cart/order/create'
  }
  return fetch({
    url,
    method: 'post',
    data
  })
}
